import React from 'react'

interface Props {
  callHistory: any
}

const TablePassedCalls: React.FC<Props> = ({callHistory}) => {
  const checkValueEntered = (index: number, activityStatementList: any) => {
    var resp = ''
    if (activityStatementList === undefined || !(activityStatementList?.length > 0)) {
      resp = ''
    } else {
      if (activityStatementList[index]?.value === undefined) {
        resp = '-'
      } else if (activityStatementList[index]?.value === '') {
        resp = '-'
      } else {
        resp = activityStatementList[index]?.value
      }
    }

    return resp
  }

  console.log('callHistorycallHistory', callHistory)

  return (
    <div className='card'>
      {/* begin::Body */}
      <div className='card-body py-3'>
        {/* begin::Table container */}
        <div className='table-responsive'>
          {/* begin::Table */}
          <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
            {/* begin::Table head */}
            <thead>
              <tr className='fw-bolder text-gray-800 text-muted border-bottom border-primary'>
                <th className='min-w-80px text-primary'>Aktivite ID</th>
                <th className='min-w-140px'>Arama Sonucu</th>
                <th className='min-w-120px'>Ödeme Kanalı</th>
                <th className='min-w-120px text-center'>Arama Tarihi</th>
                <th className='min-w-120px text-center'>Uzlaşılan Tarih</th>
                <th className='min-w-50px'>Not</th>
              </tr>
            </thead>
            {/* end::Table head */}
            {/* begin::Table body */}
            <tbody>
              {callHistory !== undefined &&
                callHistory
                  .sort((a: any, b: any) => (a.node.activityId > b.node.activityId ? -1 : 0))
                  .map((activity: any) => (
                    <tr key={activity.node.activityId}>
                      <td>
                        <span className='text-primary fw-bold text-hover-dark d-block fs-6'>
                          {activity.node.activityId}
                        </span>
                      </td>
                      <td>
                        <span className='text-muted fw-bold text-hover-primary d-block fs-7'>
                          {checkValueEntered(3, activity.node.activityStatements)}
                        </span>
                      </td>
                      <td>
                        <span className='text-muted fw-bold text-muted d-block fs-7'>
                          {checkValueEntered(5, activity.node.activityStatements)}
                        </span>
                      </td>
                      <td>
                        <span className='text-muted fw-bold text-muted d-block fs-7'>
                          {`${activity.node.planDateTime.split('T')[0].split('-')[0]}-${
                            activity.node.planDateTime.split('T')[0].split('-')[1]
                          }-${activity.node.planDateTime.split('T')[0].split('-')[2]}`}
                        </span>
                      </td>
                      <td>
                        <span className='text-muted fw-bold text-muted d-block fs-7'>
                          {checkValueEntered(6, activity.node.activityStatements).split(' ')[0]}
                        </span>
                      </td>
                      <td>
                        <span className='text-muted fw-bold d-block fs-7'>
                          {checkValueEntered(1, activity.node.activityStatements)}
                        </span>
                      </td>
                    </tr>
                  ))}
            </tbody>
            {/* end::Table body */}
          </table>
          {/* end::Table */}
        </div>
        {/* end::Table container */}
      </div>
      {/* begin::Body */}
    </div>
  )
}

export default TablePassedCalls
